<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-card flat class="text-xs-center ma-3" width="100%">

                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;"><v-icon color="white"> mdi-filter </v-icon> Filtro</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                Establecer algún criterio de búsqueda:
                            </v-col>
                        </v-row>
                        <v-form ref="form" v-model="validForm" lazy-validation>
                            <v-row ma="3" justify="center">
                                <v-col cols="12" md="2" class="d-flex align-center pb-8">
                                    <span>
                                        Rango de Fechas:
                                    </span>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-menu ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            maxlength="16"
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fecha"
                                                          outlined
                                                          v-bind="attrs"
                                                          readonly
                                                          :rules="[rules.required]"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date"
                                                       locale="es-mx"
                                                       :max="minfecha"
                                                       @input="menu = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="1" class="d-flex align-center pb-8" >
                                    <v-row justify="center">
                                        <span style="text-align: center">al</span>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-menu ref="menu2"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            maxlength="16"
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fechafin"
                                                          outlined
                                                          v-bind="attrs"
                                                          readonly
                                                          :rules="[rules.required]"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="datefin"
                                                       locale="es-mx"
                                                       :max="minfecha"
                                                       @input="menu2 = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       title="Buscar"
                                       @click="Buscar()">
                                    <span style='color: white;'>Buscar</span>
                                </v-btn>
                                <v-btn class="ma-2"
                                       title="Limpiar"
                                       color="default"
                                       @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br />
        <v-card class="text-xs-center" width="100%">
            <v-card-title class=" primary">
                <span class="card-title-text" style="color: white;">
                    <v-icon color="white"> mdi-chart-bar </v-icon> Resultado de la búsqueda
                </span>
                <v-spacer></v-spacer>
                <div>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" @click="Descargar()">
                                <v-icon dark style="cursor: pointer !important" class="hover">
                                    mdi-file-excel-outline
                                </v-icon>

                            </span>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </div>
            </v-card-title>
            <v-card-text>
                <v-row v-if="busca">
                    <v-col cols="12" md="12" class="ma-2">
                        <DataTable :url="url"
                                   :columns="head"
                                   :formatterActions="formatterActions"
                                   :params="displayInputs"
                                   :order="[]"
                                   @registro="NumRegistro"
                                   @apiDT="apiDT = $event">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
       
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import moment from "moment";
    import General from "@/services/Operacion/Operacion.service.js";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import { read, utils, writeFileXLSX } from 'xlsx';
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                showcargando: true,
                validForm: true,
                menu: false,
                menu2: false,
                fecha: '',
                date: '',
                minfecha: '',
                fechafin: '',
                datefin: '',
                asig: 0,
                busca: false,
                url: 'Operacion/ObtenerEstadisticaGeneral',
                head: [
                    { name: "Reporte", data: "Reporte", title: "Reporte", formatter: [this, "detalleReporte"], },
                    { name: "FechaReporte", data: "FechaReporte", title: "Fecha Reporte" },
                    { name: "FechaContacto", data: "FechaContacto", title: "Fecha Contacto" },
                    { name: "FechaTermino", data: "FechaTermino", title: "Fecha Termino" },
                    { name: "FechaConclusion", data: "FechaConclusion", title: "Fecha Conclusion" },
                    { name: "FechaCerrado", data: "FechaCerrado", title: "Fecha Cerrado" },
                    { name: "Localidad", data: "Localidad", title: "Localidad" },
                    { name: "Estado", data: "Estado", title: "Estado" },
                    { name: "Aseguradora", data: "Aseguradora", title: "Aseguradora",},
                    { name: "Flotilla", data: "Flotilla", title: "Flotilla" },
                    { name: "Proveedor", data: "Proveedor", title: "Proveedor" },
                    { name: "Supervisor", data: "Supervisor", title: "Supervisor" },
                    { name: "Gerencia", data: "Gerencia", title: "Gerencia" },
                    { name: "Asistencia", data: "Asistencia", title: "Asistencia" },
                    { name: "Estatus", data: "Estatus", title: "Estatus" },
                ],
                displayInputs: {
                    fecha: '',
                    fechafin: ''
                },
                formatterActions: [
                    { click: [this, "BuscarReporte"] },
                ],
                rules: {
                    required: value => !!value || 'Campo requerido',
                },
                nombreArchivo: `EstadisticaGeneral_${this.$moment().format("YYYY-MM-DD")}`,
                listado: '',
                ContadorTabla: 0,
            }
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
        watch: {
            //fecha(val) {
            //},
            date(val) {
                this.fecha = this.formatDate(this.date);
               
                if (moment(this.date) > moment(this.datefin))
                    this.fechafin = '';
            }, 
            datefin(val) {
                this.fechafin = this.formatDate(this.datefin);
                if (moment(this.date) > moment(this.datefin))
                    this.fecha ='';
            },

        },
        methods: {
            
            detalleReporte(datos) {
                if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                    return `<div class="ml-3"><button data-action="0" data-params="${datos.nrreporte}" class="dt-formatterAction ma-1 reporteindice">${datos.nrreporte}-${datos.svindice}</span></button></div>`;
                } else {
                    return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
                }
            },
            async BuscarReporte(params, item, fila) {
                let reporte = {
                    nrreporte: item.nrreporte,
                    svindice: item.svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.nrreporte);
                formData.append("svindice", item.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });
                let url = '';

                if (ver == 0) {
                    url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
                }
                else {
                    let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
                    //let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    //url = this.$router.resolve({ name: `${routerName}` });
                    url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });
                }
                window.open(url.href, '_blank');
            },
            NumRegistro(nombre, count) {
                this.ContadorTabla = count;
            },
            async Descargar() {
                if (this.ContadorTabla > 0) {
                    this.showcargando = true;
                    let datosbusqueda = new FormData();

                    datosbusqueda.append("fecha", this.fecha.length == 0 ? '' : this.date);
                    datosbusqueda.append("fechafin", this.fechafin.length == 0 ? '' : this.datefin);
                    await General.ObtenerEstadisticaGeneral(this, datosbusqueda).then(
                        (resp) => {
                            let aux_listado = resp;
                            for (let i in aux_listado) {
                                for (const [key, value] of Object.entries(aux_listado[i])) {
                                    if (typeof value === "object") {
                                        aux_listado[i][key] = "";
                                    } else {
                                        aux_listado[i][key] = value.toString();
                                    }
                                }
                            }
                            const ws = utils.json_to_sheet(aux_listado);
                            const wb = utils.book_new();
                            utils.book_append_sheet(wb, ws, "Data");
                            writeFileXLSX(wb, this.nombreArchivo + ".xlsx");

                            this.showcargando = false;
                            
                            var formData = new FormData();
                            formData.append("lasitio", 'Prusia+');
                            formData.append("lomodulo", 'EstadisticaGeneral');
                            formData.append("laaccion", "Descargar Archivo excel");
                            formData.append("lacaracteristicas", 'Estadistica General ');
                            formData.append("lanombre", this.nombreArchivo + ".xlsx");
                            formData.append("ladestinatario", " ");
                            Archivos.AlmacenarVisitas(formData).then(data => {
                            });
                        }
                    );
                    
                }
                else {
                    this.$swal(
                        "Atención",
                        "Tiene que realizar una búsqueda que tenga resultados para poder descargar el archivo en Excel",
                        "info"
                    );
                }
            },
            setWidth(api) {
                this.apiDT = api
                api.columns.adjust().responsive.recalc()
                this.$emit("apiDT", api);
            },
            CancelarShow() {
                
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            async Buscar() {
               
                if (this.$refs.form.validate()) {
                    this.busca = true;
                    this.displayInputs.fecha = this.fecha.length == 0 ? '' : this.date;
                    this.displayInputs.fechafin = this.fechafin.length == 0 ? '' : this.datefin;
                    this.reloadTable();
                    this.RegistrarBusqueda();
                }
            },
            Limpiar() {
                this.showcargando = true;
                this.asig = 0;
                this.$refs.form.reset();
                this.minfecha = moment().format("YYYY[-]MM[-]DD");
                this.date = moment().format("YYYY[-]MM[-]DD");
                this.datefin = moment().format("YYYY[-]MM[-]DD");
                
                if (this.apiDT != null)
                    this.apiDT.clear().draw();

                setTimeout(() => {
                    this.fecha = '';
                    this.fechafin = '';
                    this.date = null;
                    this.datefin = null;
                    //this.$refs.form.reset();
                    this.showcargando = false;
                }, 1000);
                
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            RegistrarBusqueda(){
                let arr = window.location.pathname.split("/");

                MetodosGenerales.registrarPaginaVisitada(
                        'Estadistica', //modulo
                        `Estadistica-${arr[arr.length-1]}-Busqueda`,   //name
                        window.location.origin + window.location.pathname, //   url    
                        this.domain.domainNameForApi,
                        null,    //nrreporte,
                        null//svindice
                    );
            },
        },
        async mounted() {
            this.minfecha = moment().format("YYYY[-]MM[-]DD");

            setTimeout(() => {
                this.showcargando = false;
            }, 3000);
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '133').then(response => {

                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        },
       
    }
</script>
<style scoped>

</style>